import { Link } from 'react-router-dom';
import { MapPin, Award, CheckCircle, AlertCircle, XCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';

export const ProfessionalCard = ({ professional }) => {
  const getStatusConfig = (estatus) => {
    switch (estatus) {
      case 'Activo':
        return {
          icon: CheckCircle,
          className: 'status-active',
          label: 'Activo'
        };
      case 'Suspendido':
        return {
          icon: AlertCircle,
          className: 'status-suspended',
          label: 'Suspendido'
        };
      case 'Baja':
        return {
          icon: XCircle,
          className: 'status-inactive',
          label: 'Baja'
        };
      default:
        return {
          icon: CheckCircle,
          className: 'status-inactive',
          label: estatus
        };
    }
  };

  const statusConfig = getStatusConfig(professional.estatus);
  const StatusIcon = statusConfig.icon;

  return (
    <div 
      className="professional-card card-lift"
      data-testid={`professional-card-${professional.id}`}
    >
      <div className="flex items-start gap-4">
        {/* Avatar */}
        <div className="flex-shrink-0">
          <img
            src={professional.foto || `https://api.dicebear.com/7.x/initials/svg?seed=${professional.nombre}&backgroundColor=f8fafc`}
            alt={professional.nombre}
            className="w-16 h-16 rounded-lg object-cover bg-slate-100"
            data-testid={`professional-avatar-${professional.id}`}
          />
        </div>

        {/* Info */}
        <div className="flex-1 min-w-0">
          {/* Name and Status */}
          <div className="flex items-start justify-between gap-2 mb-1">
            <h3 className="font-manrope font-semibold text-slate-900 text-base truncate">
              {professional.nombre}
            </h3>
          </div>

          {/* Registration Number */}
          <p className="text-xs text-slate-500 mb-2 font-mono">
            {professional.numero_registro}
          </p>

          {/* Badges Row */}
          <div className="flex flex-wrap items-center gap-2 mb-3">
            <span className={`status-badge ${statusConfig.className}`}>
              <StatusIcon className="w-3 h-3" />
              {statusConfig.label}
            </span>
            <span className="rank-badge">
              <Award className="w-3 h-3 inline mr-1" />
              {professional.rango}
            </span>
          </div>

          {/* Location */}
          <div className="flex items-center text-sm text-slate-600 mb-3">
            <MapPin className="w-4 h-4 mr-1 text-slate-400" />
            <span>{professional.ciudad}, {professional.estado}</span>
          </div>

          {/* Specialties */}
          {professional.especialidades && professional.especialidades.length > 0 && (
            <div className="flex flex-wrap gap-1 mb-4">
              {professional.especialidades.slice(0, 2).map((esp, index) => (
                <Badge 
                  key={index} 
                  variant="secondary"
                  className="text-xs bg-slate-100 text-slate-600 hover:bg-slate-100"
                >
                  {esp}
                </Badge>
              ))}
              {professional.especialidades.length > 2 && (
                <Badge 
                  variant="secondary"
                  className="text-xs bg-slate-100 text-slate-500 hover:bg-slate-100"
                >
                  +{professional.especialidades.length - 2}
                </Badge>
              )}
            </div>
          )}

          {/* Actions */}
          <div className="flex gap-2">
            <Link to={`/profesional/${professional.id}`} className="flex-1">
              <Button 
                variant="outline" 
                size="sm" 
                className="w-full text-slate-700 border-slate-200 hover:bg-slate-50"
                data-testid={`view-profile-btn-${professional.id}`}
              >
                Ver Perfil
              </Button>
            </Link>
            {professional.estatus === 'Activo' && (
              <Link to={`/profesional/${professional.id}?contactar=true`}>
                <Button 
                  size="sm"
                  className="bg-slate-900 hover:bg-slate-800 text-white"
                  data-testid={`contact-btn-${professional.id}`}
                >
                  Contactar
                </Button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
